export default __webpack_public_path__ + "static/media/tobi-less@3x.5592e544.png";